export default __webpack_public_path__ + "static/refinance-6b0bd9bbea1277018b20ca2ef09e4cbc.png";